const header = document.querySelector(".header");
const body = document.querySelector(".body");

export function initHeaderScroll() {
  if (!header) return;

  let prevScrollPos = window.scrollY;
  const headerHeight = window.innerWidth <= 1100 ? 70 : 143;

  window.addEventListener("scroll", () => {
    const currentScrollPos = window.scrollY;

    if (currentScrollPos > headerHeight) {
      if (!header.classList.contains("header-new")) {
        header.classList.add("header-new");
        body.style.paddingTop = "73px";
      }

      if (currentScrollPos < prevScrollPos) {
        header.classList.add("active");
        header.style.pointerEvents = "auto"; // Активируем клики при появлении
      } else {
        header.classList.remove("active");
        header.style.pointerEvents = "none"; // Отключаем клики при скрытии
      }
    } else if (currentScrollPos < headerHeight / 2) {
      header.classList.remove("header-new");
      body.style.paddingTop = "0";
      header.classList.remove("active");
      header.style.pointerEvents = "auto"; // Включаем клики для видимого состояния
    }

    prevScrollPos = currentScrollPos;
  });
}
